var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{attrs:{"type":"error","value":true},on:{"input":_vm.onClose}},[_c('b',[_vm._v(_vm._s(_vm.title)+":")]),_c('br'),_vm._v(_vm._s(_vm.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }